import { Flex } from '@/ui';
import type { ThumbnailKind } from './LayoutThumbnails';
import { THUMBNAILS } from './LayoutThumbnails';

export type { ThumbnailKind } from './LayoutThumbnails';

type Props = {
  kind: ThumbnailKind;
};

// Shared 96×62 frame; the kind selects which skeleton module renders inside it.
export const LayoutThumbnail = ({ kind }: Props) => {
  const Thumbnail = THUMBNAILS[kind];
  return (
    <Flex
      align="flex-start"
      bg="surface.card"
      border="1px solid"
      borderColor="line.soft"
      borderRadius="ah-md"
      flexShrink={0}
      h="62px"
      overflow="hidden"
      p={2}
      w="96px"
    >
      <Thumbnail />
    </Flex>
  );
};
